import type {RouteLocationNormalized} from 'vue-router';
import {defineNuxtRouteMiddleware, useGuestHost, navigateTo} from '#imports';
import {useLandingInvitationStore} from '~/store/landing-invitation.store';

export default defineNuxtRouteMiddleware(async (to: RouteLocationNormalized) => {
    const host = useGuestHost();
    const freelancersListId = to.query.freelancersList;

    if (!freelancersListId) {
        return;
    }

    const idType = Number(to.query.a) as 0 | 1 | 2;
    const id = to.query.code as string;

    const landingInvitationStore = useLandingInvitationStore();
    landingInvitationStore.init(id, idType);

    try {
        const belongsToCompany = await landingInvitationStore.belongsToCompany();

        if (belongsToCompany.hasAccess) {
            return navigateTo(`${host}/client/freelancers/list/${freelancersListId}`, {external: true});
        }
    } catch (e) {}
});
